import type { IconButtonProps } from "@mui/material";
import { IconButton } from "@mui/material";
import classNames from "classnames";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { SaveIconDiskette } from "../../../../shared/icons/SaveIconDiskette";
import { AppPopover } from "../../../AppPopover";
import { usePopover } from "../../../hooks/use-popover";
import styles from "../styles.module.css";

interface Props extends IconButtonProps {
  name: string;
  onRefreshVersion: () => void;
  isDisabled: boolean;
}

export const SaveVersionAction: FC<Props> = ({
  name,
  onRefreshVersion,
  isDisabled,
  ...props
}) => {
  const {
    anchorPopoverEl,
    openPopover,
    handleOpenPopover,
    handleClosePopover,
  } = usePopover();
  const { t } = useTranslation();
  return (
    <>
      <IconButton
        className={classNames(styles["action-button"], {
          [styles["disabled"]]: name === undefined || isDisabled,
        })}
        onClick={handleOpenPopover}
        disabled={name === undefined || isDisabled}
        {...props}
      >
        <SaveIconDiskette />
      </IconButton>
      <AppPopover
        open={openPopover}
        anchorEl={anchorPopoverEl}
        handleClose={handleClosePopover}
        onOk={() => {
          onRefreshVersion();
          handleClosePopover();
        }}
      >
        {t("versioning.update_popover")}
        <strong>{name}</strong>?
      </AppPopover>
    </>
  );
};
